module.exports = __webpack_public_path__ + "img/distribution.78ef8efa.png";